import {
  CANDIDATE_UPDATE_PROJECT_REQUEST,
  CANDIDATE_UPDATE_PROJECT_SUCCESS,
  CANDIDATE_UPDATE_PROJECT_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CandidateUpdateProjectAction = (data, navigate) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_UPDATE_PROJECT_REQUEST,
      payload: true,
    });

    const token = localStorage.getItem("token");

    try {
      const OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/update_project`,
        method: "PUT",
        data: data,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      const res = await axios(OPTION);

      dispatch(UpdateCandidateProjectPre(res.data));
      toast.success("Project Updated Successfully");

      setTimeout(() => {
        navigate("/candidate_dashboard");
      }, 1500);

      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.status?.message || "Failed To Update Project!";

      toast.error(message);

      dispatch({
        type: CANDIDATE_UPDATE_PROJECT_FAIL,
        payload: false,
        error: message,
      });

      throw error;
    }
  };
};

export const UpdateCandidateProjectPre = (data) => {
  return {
    type: CANDIDATE_UPDATE_PROJECT_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
